<template>
  <div class="login" @keyup.enter="login">
    <h2>{{ isCheckedEmail? $t("auth.setPassword") : $t("auth.forgetPasswordEmail") }}</h2>
    <form
      name="login"
      :model="forgetFrom"
      :rules="rules"
      ref="forgetFrom"
      onsubmit="return false"
    >
      <div v-show="!isCheckedEmail">
        <div class="form-group" :class="{'has-error': errors.has('Email'), 'valid': isFormFieldValid('Email')}">
          <div class="input-group">
            <input
              type="text"
              name="Email"
              v-model="forgetFrom.Email"
              :placeholder="$t('auth.email')"
              autocomplete="off"
              v-validate="'required|email'"
              required
            />
            <i class="bar" />
            <small v-show="errors.has('Email')"
                   class="help text-danger">{{ errors.first('Email') }}</small>
          </div>
        </div>
        <p class="back-login">
          <span @click="backToLogin">{{ $t("backToLoginPage") }}</span>
        </p>
        <div class="d-flex align--center justify--space-between justify-center">
          <button
            class="btn btn-primary"
            :class="{ loading: isLoading }"
            type="button"
            id="login1"
            @click="checkOutEmail"
            :disabled="isLoading"
          >
            {{ isLoading ? "" : $t("auth.confirm") }}
            <Spinner v-if="isLoading" size="small" />
            <span v-if="isLoading" class="spinner-text">{{ $t("loading") }}</span>
          </button>

        </div>
      </div>
      <div v-show="isCheckedEmail">
        <div class="form-group" :class="{'has-error': errors.has('password'), 'valid': isFormFieldValid('password')}">
          <div class="input-group">
            <input
              type="password"
              name="password"
              v-model="forgetFrom.password"
              :placeholder="$t('auth.password')"
              autocomplete="new-password"
              v-validate="'required|verifyPassword|validPassword'"
              required
              ref="passwordInput"
              onkeyup="value=value.replace(/\s/g,'')"
              onkeydown="value=value.replace(/\s/g,'')"
            />
            <i class="bar" /><small v-show="errors.has('password')"
                   class="help text-danger">{{ errors.first('password') }}</small>
          </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.has('confirmPassword'), 'valid': isFormFieldValid('confirmPassword')}">
          <div class="input-group">
            <input
              type="password"
              name="confirmPassword"
              v-model="forgetFrom.confirmPassword"
              :placeholder="$t('auth.confirmPassword')"
              autocomplete="new-password"
              v-validate="'required|verifyConfirmPassword|validPassword'"
              required
              onkeyup="value=value.replace(/\s/g,'')"
              onkeydown="value=value.replace(/\s/g,'')"
            />
            <i class="bar" /><small v-show="errors.has('confirmPassword')"
                   class="help text-danger">{{ errors.first('confirmPassword') }}</small>
          </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.has('verficationCode'), 'valid': isFormFieldValid('verficationCode')}">
          <div class="input-group">
            <input
              name="verficationCode"
              v-model="forgetFrom.verficationCode"
              :placeholder="$t('auth.verficationCode')"
              autocomplete="off"
              v-validate="'required'"
              required
            />
            <i class="bar" />
            <small v-show="errors.has('verficationCode')"
                   class="help text-danger">{{ errors.first('verficationCode') }}</small>
          </div>
        </div>
        <p class="verification-time">The verification code is valid for {{remainingTime}} minutes</p>
        <p class="back-login">
          <span @click="backToLogin">{{ $t("backToLoginPage") }}</span>
        </p>
        <div class="d-flex align--center justify--space-between justify-center">
          <button
            class="btn btn-primary"
            :class="{ loading: isLoading }"
            type="button"
            id="login2"
            @click="resetPassword"
            :disabled="isLoading"
          >
            {{ isLoading ? "" : $t("auth.confirm") }}
            <Spinner v-if="isLoading" size="small" />
            <span v-if="isLoading" class="spinner-text">{{ $t("loading") }}</span>
          </button>

        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import qs from "qs";
import { request } from "@/utils/utils";
import pageName from "../../NewUser/pageNames";
import Spinner from "vue-simple-spinner";

export default {
  name: "login",
  components: { Spinner },
  data() {
    let that = this;
    this.$validator.extend('verifyPassword', {
      validate: (value, ref) => {
        that.$validator.validateAll({"confirmPassword": that.forgetFrom.confirmPassword})
        return true
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    this.$validator.extend('verifyConfirmPassword', {
      validate: (value, ref) => {
        if (value != that.forgetFrom.password) {
          return false
        } else {
          return true
        }
      },
      getMessage: (field) => 'The ' + field + ' do not match with password.'
    })
    let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
    this.$validator.extend('validPassword', {
      validate: (value, ref) => {
        if (!regExpPassword.test(value)) {
          return false
        } else {
          return true
        }
      },
      getMessage: (field) => this.$t('t.newPasswordMustBe')
    })

    return {
      forgetFrom: {
        Email: "",
        password: "",
        confirmPassword: "",
        verficationCode: ""
      },
      isLoading: false,
      rules: {},
      token: localStorage.getItem("Authorization"),
      isCheckedEmail: false,
      remainingTime: 0
    };
  },
  created() {
    this.isCheckedEmail = false;
  },
  methods: {
    ...mapMutations(["changeLogin", "setUser"]),
    login(event) {
      if (event.keyCode === 13 || event.keyCode == 100) {
        if (!this.isCheckedEmail) {
          this.checkOutEmail();
        } else {
          this.resetPassword();
        }

      }
    },
    checkOutEmail() {
      let that = this;
      that.$validator.validateAll({Email: that.forgetFrom.Email}).then(result => {
        if (result) {
          this.isLoading = true;
          request({
            method: "post",
            url: `api/dashboard/forgot-password?login_name=${that.forgetFrom.Email}`
          }).then(response => {
            if (response.data.code === "10000") {
              that.remainingTime = Math.ceil(response.data.data/60)
              that.isCheckedEmail = true
              that.$validator.reset()
            } else {
              that.$message({
                duration: 2000,
                message: response.data.msg,
                type: "error"
              });
            }
            that.isLoading = false;
          }).catch(err => {
              that.$message({
                duration: 2000,
                message: "Opps something went wrong!",
                type: "error"
              });
              that.isLoading = false;
            });

        }
      })
    },
    resetPassword() {
      let that = this;
      let resetData = {
        password: that.forgetFrom.password,
        confirmPassword: that.forgetFrom.confirmPassword,
        verficationCode: that.forgetFrom.verficationCode
      }
      that.$validator.validateAll(resetData).then(result => {
        if (result) {
          that.isLoading = true;
          request({
            method: "post",
            url: `api/dashboard/verify-reset-code?login_name=${that.forgetFrom.Email}&verify_code=${that.forgetFrom.verficationCode}&password=${that.forgetFrom.password}`
          }).then(response => {
            if (response.data.code === "10000") {
              that.$message({
                duration: 2000,
                message: "Reset password success",
                type: "success"
              });
              // that.$router.push({path: "/auth/login"})
              window.location.href = `${location.origin}`
            } else {
              that.$message({
                duration: 2000,
                message: response.data.msg,
                type: "error"
              });
            }
            that.isLoading = false;
          }).catch(err => {
              that.$message({
                duration: 2000,
                message: "Opps something went wrong!",
                type: "error"
              });
              that.isLoading = false;
            });
        }
      })
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    backToLogin() {
      // this.$router.push({path: "/auth/login"})
      window.location.href = `${location.origin}`
    }
  }
};
</script>

<style lang="scss">
.loading {
  display: flex;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  text-transform: none;

  .spinner-text {
    font-size: 14px;
    margin-left: 10px;
    color: #ffffff;
  }
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
}
.login {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
    .down-container {
      display: none;
    }
  }

  h2 {
    text-align: center;
  }
  width: 21.375rem;

  .down-container {
    margin-top: 3.125rem;
  }
  .justify-center {
    justify-content: center;
  }
  .back-login {
    margin-top: -1.55rem;
    margin-bottom: 2.25rem;
    text-align: right;
    color: #34495e;
    span {
      cursor: pointer;
    }
    span:hover {
      color: #899c7c;
    }
  }
  .verification-time {
    font-size: 1rem;
    color: green;
    margin-top: -1.75rem;
    margin-bottom: 2rem;
  }
}

@media screen and (max-width: 991px) {
  .d-flex.align--center {
    justify-content: center;
  }
}
</style>
